import { IApplicationState } from '../../types/redux';
import { getLastContentStep } from '../../utils/newReview/steps';

export const selectIsLastContentStep = (state: IApplicationState): boolean => {
  return state.newReview.meta.step === getLastContentStep(state.newReview.meta.mode);
};
